import { createContext, useContext, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

// reducers
import { dehydrateUser, fetchUser } from "../stores/user";

// const
const UserContext = createContext();

export const useUserContext = () => {
  const context = useContext(UserContext);
  if (context === undefined) {
    throw new Error("useUserContext must be used within a UserProvider");
  }
  return context;
}

export const UserProvider = (props) => {

  // input
  const { children } = props;

  // hooks
  const dispatch = useDispatch();
  const user = useSelector(context => context.user);
  const { initialized } = user;

  // effects
  useEffect(() => {
    console.log('providers.user@useEffect[]', 'Invoked');
    dispatch(fetchUser())
  }, [])

  return (
    <UserContext.Provider value={{...user}}>
      {initialized && children}
    </UserContext.Provider>
  )
}